import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios'

// system views
import NotFound from './views/BasePages/NotFound';

// Main view
import Dashboard from './views/Dashboard';
import Home from './views/Dashboard/Home';

// Listing Views
import ListingParent from './views/Listing/ListingParent';
import ListingInfo from './views/Listing/ListingInfo';
import {setCookie, getCookie} from "./cookie";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dashboard',
      component: Dashboard,
      beforeEnter(to, from, next) {
        let newToken = getCookie('token').split(',')[0];

        axios.get('/tokens/').then(function () {
          next();
        }).catch(function () {
          setCookie('token', newToken);
          location.reload();
        })
      },
      children: [{
        path: '/',
        name: 'landing',
        component: Home
      },
        {
          path: '/listing/:id/',
          component: ListingParent,
          children: [
            {
              path: '',
            },
            {
              path: 'info',
              name: 'listing-info',
              component: ListingInfo
            }
          ]
        }]
    },
    {
      path: '/',
      redirect: 'dashboard'
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})